import React from 'react'
import {Section} from 'jbc-front/components/Form'
import {
  reduxForm,
  FieldArray,
  formValueSelector,
  isSubmitting as isSubmittingForm,
  autofill as autofillForm,
  stopSubmit as stopSubmitForm,
  touch as touchForm,
} from 'redux-form'
import Button from 'jbc-front/components/Button'
import FormErrors, {onSubmitFail} from 'jbc-front/components/FormErrors'
import {renderDependents} from 'employees/form/Dependents'
import Marital from 'employees/form/Marital'
import EmployeeName from 'procedures/EmployeeName'
import {connect} from 'react-redux'
import {Consumer as AsyncTaskConsumer} from 'AsyncTask'
import ReviewComments from 'components/ReviewComments'
import {flow} from 'lodash/fp'
import {validateDependent} from 'employees/form/Dependents'
import {set} from 'lodash'
import {DateField} from 'FormFields'

export const formName = 'changeDependents'
const selector = formValueSelector(formName)
export const isSubmitting = isSubmittingForm(formName)
export const autofill = autofillForm.bind(null, formName)
export const stopSubmit = stopSubmitForm.bind(null, formName)
export const touch = touchForm.bind(null, formName)

const Form = ({setMarried, submitting, handleSubmit, otherButtons, employee, submitText = '次へ', comments}) => (
  <form className="new_boarding_procedure" onSubmit={handleSubmit}>
    <div className="l-title-wrap">
      <h1 className="m-title-main">家族情報の追加</h1>
      <EmployeeName employee={employee} />
    </div>
    <div className="basic_information">
      <FormErrors />
      <ReviewComments comments={comments} />
      <Section title="被扶養者異動日">
        <DateField
          name="date_on"
          label="被扶養者になった日"
          note="子供が生まれた場合は「出生日」を、結婚の場合は「結婚した日」を入力します。"
        />
      </Section>
      <Section title="家族情報">
        <FieldArray
          name="dependents"
          component={renderDependents}
          procedureType="add_dependents"
          formName={formName}
          setMarried={setMarried}
          selector={selector}
          autofill={autofill}
          canAdd
          canDelete
        />
      </Section>
      <Marital selector={selector} />
      <div className="u-ta-c u-mt30">
        {otherButtons}
        <AsyncTaskConsumer>
          {({taskRunningProps}) => (
            <Button primary onClick={handleSubmit} disabled={submitting} {...taskRunningProps}>
              {submitText}
            </Button>
          )}
        </AsyncTaskConsumer>
      </div>
    </div>
  </form>
)

const validate = (values) => {
  const {dependents, date_on} = values
  if (!dependents) {
    return undefined
  }

  const errors = {dependents: []}

  const needDateOn = dependents.some((dependent) => dependent.dependent_social_insurance || dependent.dependent_tax_law)
  if (needDateOn && !date_on) {
    errors.date_on = 'を入力してください'
  }

  dependents.forEach((dependent, index) => {
    const dependentErrors = validateDependent(dependent)

    if (Object.keys(dependentErrors).length > 0) {
      Object.entries(dependentErrors).forEach(([field, message]) => {
        set(errors.dependents, `[${index}].${field}`, message)
      })
    }
    if (dependent.is_report_target && dependent.dependent_social_insurance === false) {
      set(errors.dependents, `[${index}].is_report_target`, 'は、社会保険の扶養でないと記載することができません。')
    }
  })

  return errors.date_on || Object.keys(errors.dependents).length > 0 ? errors : undefined
}

export default flow(
  reduxForm({
    form: formName,
    enableReinitialize: true,
    onSubmitFail,
    validate,
  }),
  connect(null, (dispatch) => ({
    setMarried(e, value, oldValue) {
      if (value === 'spouse' && oldValue !== 'spouse') {
        dispatch(autofill('marital_status', 'married'))
      }
    },
  }))
)(Form)
